import cn from 'classnames';

const options = [
  { value: 'streets', label: 'Map' },
  { value: 'satellite', label: 'Satellite' },
];

export const MapStyleToggle = ({ value, onChange }) => (
  <div className="absolute left-2 bottom-6 z-[2] flex overflow-hidden rounded-md bg-whiteColor text-xs shadow">
    {options.map(option => (
      <button
        key={option.value}
        type="button"
        onClick={() => onChange(option.value)}
        className={cn('px-2.5 py-1.5', {
          'bg-blackColor text-whiteColor': value === option.value,
          'text-blackColor hover:bg-gray-100': value !== option.value,
        })}
      >
        {option.label}
      </button>
    ))}
  </div>
);
